import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-validar-maxlength[form][campo]',
  template: `
  <ng-container
  *ngIf="form.controls[campo].hasError('maxlength') &&
  (form.controls[campo].dirty ||
    form.controls[campo].touched)
    ">
   Esse campo é permitido no máximo {{ form.controls[campo].errors.maxlength.requiredLength }} caracteres
  </ng-container>`
})
export class ValidarMaxlengthComponent {

  @Input() campo: string;
  @Input() nome: string;
  @Input() form: FormGroup;

}
